export const lifeType = [
    {name: "电费", type: "fees", jingle: "电费红包"},
    {name: "水费", type: "water", jingle: "水费红包"},
    {name: "燃气费", type: "gas", jingle: "燃气费红包"},
]

export const hotCity = [
    "成都", "昆明", "重庆", "杭州", "西安",
    "长沙", "广州", "武汉", "南京", "贵阳",
    "北京", "上海", "深圳", "苏州"
];

export const playMiles = {
    url: "https://scal-rest.jifen360.com/index.php",
    token: "dzr8EKb3TPlH7uZ1Qtaaxjatij2ibsJf",
    scalKeys: "sdfer43523fdf",
    scalChannelType: "JIFEN360"
}
